import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

const get = (path) => {
  if (!BASE) {
    console.warn(`API call skipped: REACT_APP_BACKEND_URL is not defined. Path: ${path}`);
    return Promise.reject(new Error("REACT_APP_BACKEND_URL is missing"));
  }
  return axios.get(`${BASE}${path}`).then((r) => r.data);
};

export const api = {
  getServices:   ()     => get("/api/services"),
  getService:    (slug) => get(`/api/services/${slug}`),
  getBlogPosts:  ()     => get("/api/blog"),
  getBlogPost:   (slug) => get(`/api/blog/${slug}`),
  getProducts:   ()     => get("/api/products"),
  getCompany:    ()     => get("/api/company"),
};
